
export default {
  props: {
    resultado: { type: Object, required: true }
  },
  computed: {
    getMonedaShow() {
      let moneda = this.$store.getters.getMoneda;
      if (!moneda) {
        moneda = this.resultado.moneda;
      }
      return moneda;
    },
    urlFoto() {
      return this.resultado.foto || this.getURL('/mkte_services/images/CIR/nodisponible.png');
    }
  },
};